module.exports = __webpack_public_path__ + "img/mp1000.81bc4564.jpg";